import { PersonaleStoreService } from 'src/app/Admin/_service/personale-store.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InterventiStoreService } from './../_services/interventi-store.service';
import { DatePipe } from '@angular/common';
import { ApiRestService } from './../_services/api-rest.service';
import { AuthenticationService } from 'src/app/Login/_services/authentication.service';
import { InterventiTecnico } from './../Models/InterventiTecnico';
import { Component, Input, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { InterventoComponent } from '../intervento/intervento.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { Persona } from '../../Admin/models/persona';

@Component({
  selector: 'app-interventi-giornalieri',
  templateUrl: './interventi-giornalieri.component.html'
})
export class InterventiGiornalieriComponent implements OnInit {
  utentidropdownSettings: IDropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: false,
    idField: 'id',
    textField: 'fullName',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  managers: Persona[] = [];
  managerselezionati: Persona[] = [];
  collection: InterventiTecnico[];
  today = new Date();
  @Input() giorno: string = this.datepipe.transform(this.today, 'yyyy-MM-dd');
  hasFilter: boolean = true;
  constructor(
    private ApiRest: ApiRestService,
    private datepipe: DatePipe,
    private store: InterventiStoreService,
    private modalService: NgbModal,
    private personaleStore : PersonaleStoreService,
    ) {
    store.$dataPianificazione.subscribe(data => {
      this.giorno = data;
      this.refresh();
    });
    this.personaleStore.$listaPersonale.subscribe((items) => {
      if (items && items !== null)
        this.managers = items.data;
    });
  }

  ngOnInit() {

  }
  filtroResponsabile(item: string) {
    if (item.length >= 3) {
      this.personaleStore.getListaTecnici(new RicercaPaginazione(item, 0, 1));
    }
  }
  refresh(){
    var val: number[]=[];
    if(this.managerselezionati && this.managerselezionati!=null)
      this.managerselezionati.forEach(element => val.push(element.id));
    this.ApiRest.getInterventigiornalieri(this.giorno, val).subscribe(data => this.collection = data);
  }
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }
  openModal(item) {
    this.store.updateInterventoSelezionato(item);
    this.store.updateEditable(true);
    this.store.updateShowAddForm(false);
    this.store.updateIsModal(true);
    this.modalService.open(InterventoComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg',
    });
  }

}
